import axios from 'axios';
// import host from '../ipaddress'
import host from '../components/ipaddress';

// axios.defaults.baseURL = 'http://159.65.152.211:8002';



class AuthService {
       constructor(){
       
       }
    
    login(credentials){
      
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'JWT fefege...',
          }
         return axios.post(host+"/v1/mpgps/landerDashboard/" , credentials, {
            headers: headers
        
          });
        
        //return axios.post(USER_API_BASE_URL + "generate-token", credentials);
    
    }

    generateOtp(credentials){

       // return axios.post(host+"v3/accounts/generate_login_web_otp/" , credentials);
       
       return axios.post(host+"/v1/mpgps/landerDashboard/generate_login_web_otp/", credentials);
       
       // console.log(credentials)
   }
         
   
     setToken(idToken) {
        // console.log(idToken)
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }
    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }

    
    getAuthHeader() {
       return {headers: {Authorization: 'Bearer ' + this.getUserInfo().token }};
    }
    fetch(url, options) {
        // console.log(url)
        // console.log(options)
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }
   
    logOut() {
        const token = localStorage.getItem('token');
        const refresh_token = localStorage.getItem('refresh_token');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token
        };
        return axios.post(host + "/v1/mpgps/landerDashboard/logout/",
            { refresh_token: refresh_token },
            { headers: headers }
        );
    }

    refreshToken() {
        const refresh_token = localStorage.getItem('refresh_token');
        return axios.post(host + "/v1/mpgps/landerDashboard/refresh-token/",
            { refresh_token: refresh_token }
        );
    }

    sessionHeartbeat() {
        const token = localStorage.getItem('token');
        if (!token) return Promise.resolve();
        const headers = {
            'Authorization': token
        };
        return axios.post(host + "/v1/mpgps/landerDashboard/session/heartbeat/",
            {},
            { headers: headers }
        );
    }

    endSession() {
        const token = localStorage.getItem('token');
        if (!token) return Promise.resolve();
        const headers = {
            'Authorization': token
        };
        return axios.post(host + "/v1/mpgps/landerDashboard/session/end/",
            {},
            { headers: headers }
        );
    }

    startTokenRefresh() {
        // Refresh token every 50 minutes (token expires in 60 min)
        this.tokenRefreshInterval = setInterval(() => {
            this.refreshToken().then(res => {
                if (res.data.is_success) {
                    localStorage.setItem('token', res.data.data.token);
                    console.log('Token refreshed successfully');
                }
            }).catch(err => {
                console.log('Token refresh failed:', err);
                this.stopTokenRefresh();
                this.stopHeartbeat();
                localStorage.removeItem("token");
                localStorage.removeItem("refresh_token");
                localStorage.removeItem("user");
                localStorage.removeItem("mobile_number");
                localStorage.removeItem("username");
                window.location.reload();
            });
        }, 50 * 60 * 1000); // 50 minutes
    }

    stopTokenRefresh() {
        if (this.tokenRefreshInterval) {
            clearInterval(this.tokenRefreshInterval);
            this.tokenRefreshInterval = null;
        }
    }

    startHeartbeat() {
        // Send heartbeat every 2 minutes
        this.heartbeatInterval = setInterval(() => {
            this.sessionHeartbeat().then(res => {
                if (res && res.data && !res.data.is_success) {
                    console.log('Session invalid, redirecting to login');
                    this.stopHeartbeat();
                    this.stopTokenRefresh();
                    localStorage.removeItem("token");
                    localStorage.removeItem("refresh_token");
                    localStorage.removeItem("user");
                    localStorage.removeItem("mobile_number");
                    localStorage.removeItem("username");
                    window.location.reload();
                }
            }).catch(err => {
                console.log('Heartbeat failed:', err);
            });
        }, 2 * 60 * 1000); // 2 minutes
    }

    stopHeartbeat() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    }
}

export default new AuthService();
